var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "paragraph-settings" }, [
    _c("div", { staticClass: "setting-section" }, [
      _c("div", { staticClass: "setting-label" }, [_vm._v("Üst Boşluk")]),
      _vm._v(" "),
      _c("div", { staticClass: "spacing-input" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.localMarginTop,
              expression: "localMarginTop",
              modifiers: { number: true },
            },
          ],
          staticClass: "spacing-field",
          attrs: { type: "number", min: "0", max: "100", placeholder: "0" },
          domProps: { value: _vm.localMarginTop },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.localMarginTop = _vm._n($event.target.value)
              },
              function ($event) {
                return _vm.updateMarginTop(_vm.localMarginTop)
              },
            ],
            focus: function ($event) {
              _vm.focusedField = "marginTop"
            },
            blur: [
              function ($event) {
                _vm.focusedField = null
              },
              function ($event) {
                return _vm.$forceUpdate()
              },
            ],
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "unit" }, [_vm._v("px")]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "setting-section" }, [
      _c("div", { staticClass: "setting-label" }, [_vm._v("Alt Boşluk")]),
      _vm._v(" "),
      _c("div", { staticClass: "spacing-input" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.localMarginBottom,
              expression: "localMarginBottom",
              modifiers: { number: true },
            },
          ],
          staticClass: "spacing-field",
          attrs: { type: "number", min: "0", max: "100", placeholder: "0" },
          domProps: { value: _vm.localMarginBottom },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.localMarginBottom = _vm._n($event.target.value)
              },
              function ($event) {
                return _vm.updateMarginBottom(_vm.localMarginBottom)
              },
            ],
            focus: function ($event) {
              _vm.focusedField = "marginBottom"
            },
            blur: [
              function ($event) {
                _vm.focusedField = null
              },
              function ($event) {
                return _vm.$forceUpdate()
              },
            ],
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "unit" }, [_vm._v("px")]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "setting-section" }, [
      _c("div", { staticClass: "setting-label" }, [_vm._v("Görünürlük")]),
      _vm._v(" "),
      _c("div", { staticClass: "spacing-input" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localVisibility,
              expression: "localVisibility",
            },
          ],
          staticStyle: { width: "auto", "margin-right": "8px" },
          attrs: { type: "checkbox", id: "paragraph-visibility" },
          domProps: {
            checked: Array.isArray(_vm.localVisibility)
              ? _vm._i(_vm.localVisibility, null) > -1
              : _vm.localVisibility,
          },
          on: {
            change: [
              function ($event) {
                var $$a = _vm.localVisibility,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.localVisibility = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.localVisibility = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.localVisibility = $$c
                }
              },
              _vm.updateField,
            ],
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticStyle: { cursor: "pointer" },
            attrs: { for: "paragraph-visibility" },
          },
          [_vm._v("Alan görünür")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "setting-section" }, [
      _c("div", { staticClass: "setting-label" }, [_vm._v("URL Parametresi")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localSlug,
            expression: "localSlug",
          },
        ],
        ref: "slugInput",
        staticClass: "spacing-field",
        staticStyle: { width: "100%" },
        attrs: { type: "text", placeholder: "paragraph" },
        domProps: { value: _vm.localSlug },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.localSlug = $event.target.value
            },
            function ($event) {
              return _vm.setSlug($event.target.value)
            },
          ],
        },
      }),
      _vm._v(" "),
      _c(
        "small",
        {
          staticStyle: {
            "font-size": "0.75rem",
            color: "#6b7280",
            "margin-top": "0.25rem",
            display: "block",
          },
        },
        [_vm._v("URL parametrelerinde kullanılacak benzersiz tanımlayıcı")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }